import { ExportByEmailModalTranslations } from "./export-by-email-modal-pt-br";

export const EXPORT_BY_EMAIL_MODAL_EN_US: ExportByEmailModalTranslations = {
	title: "Export report by email",
	description:
		"The selected period is greater than {{days}} days. The report will be generated in the background and sent to the provided email.",
	emailLabel: "Email",
	emailPlaceholder: "example@email.com",
	confirmButton: "Confirm sending",
	cancelButton: "Cancel",
};
